module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_L2-b54855aedc0dd23ec2851a7632eeabc9.webp";